import React from 'react';
import { SmartphoneIcon, RouterIcon, ChevronRightIcon, ZapIcon } from 'lucide-react';
const devices = [{
  name: 'iPhone 15 Pro Max',
  brand: 'Apple',
  price: 1199,
  monthly: 50,
  image: 'https://images.unsplash.com/photo-1696446701796-da61225697cc?auto=format&fit=crop&q=80&w=400',
  tag: 'Flagship'
}, {
  name: 'Samsung Galaxy S24 Ultra',
  brand: 'Samsung',
  price: 1299,
  monthly: 54,
  image: 'https://images.unsplash.com/photo-1610945265064-0e34e5519bbf?auto=format&fit=crop&q=80&w=400',
  tag: 'AI Power'
}, {
  name: 'Effy Hotspot Gateway',
  brand: 'Effy Hardware',
  price: 299,
  monthly: 12,
  image: 'https://images.unsplash.com/photo-1544197150-b99a580bb7a8?auto=format&fit=crop&q=80&w=400',
  tag: '5G Hub'
}];
export function DeviceMarketplace() {
  return <section id="marketplace" className="py-20 bg-white" data-id="element-76">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-77">
        <div className="flex flex-col md:flex-row justify-between items-end mb-12 gap-8 border-b-4 border-[#13E200] pb-6" data-id="element-78">
          <div data-id="element-79">
            <h2 className="text-4xl font-black tracking-tighter text-black uppercase italic" data-id="element-80">
              Shop <span className="text-[#13E200]" data-id="element-81">Devices</span>
            </h2>
            <p className="text-gray-500 font-bold uppercase tracking-widest text-xs mt-2" data-id="element-82">
              Get the latest tech with Effy Mobile.
            </p>
          </div>
          <button className="flex items-center gap-2 text-black font-bold uppercase tracking-widest text-xs hover:text-[#13E200] transition-colors group" data-id="element-83">
            See All Phones{' '}
            <ChevronRightIcon className="w-4 h-4 group-hover:translate-x-1 transition-transform" data-id="element-84" />
          </button>
        </div>

        <div className="grid md:grid-cols-3 gap-8" data-id="element-85">
          {devices.map((device, i) => <div key={i} className="cricket-card group" data-id="element-86">
              <div className="aspect-[4/3] relative overflow-hidden bg-gray-50 p-8 flex items-center justify-center" data-id="element-87">
                <img src={device.image} alt={device.name} className="max-h-full object-contain group-hover:scale-105 transition-all duration-500" data-id="element-88" />
                <div className="absolute top-4 left-4" data-id="element-89">
                  <span className="px-3 py-1 bg-black text-white text-[10px] font-black uppercase tracking-widest rounded-full" data-id="element-90">
                    {device.tag}
                  </span>
                </div>
              </div>

              <div className="p-6" data-id="element-91">
                <div className="mb-4" data-id="element-92">
                  <p className="text-[10px] font-black text-[#13E200] uppercase tracking-widest mb-1" data-id="element-93">
                    {device.brand}
                  </p>
                  <h3 className="text-xl font-black text-black tracking-tighter" data-id="element-94">
                    {device.name}
                  </h3>
                </div>

                <div className="space-y-2 mb-6" data-id="element-95">
                  <div className="flex justify-between items-center py-2 border-b border-gray-100" data-id="element-96">
                    <span className="text-xs text-gray-500 font-bold uppercase tracking-widest" data-id="element-97">
                      Retail Price
                    </span>
                    <span className="text-sm font-black text-black" data-id="element-98">
                      ${device.price}
                    </span>
                  </div>
                  <div className="flex justify-between items-center py-2" data-id="element-99">
                    <span className="text-xs text-gray-500 font-bold uppercase tracking-widest" data-id="element-100">
                      As low as
                    </span>
                    <span className="text-lg font-black text-[#13E200]" data-id="element-101">
                      ${device.monthly}
                      <span className="text-[10px] text-gray-400" data-id="element-102">/mo</span>
                    </span>
                  </div>
                </div>

                <button className="w-full cricket-btn-primary" data-id="element-103">Shop Now</button>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}